import React, {useState} from 'react';
import {shallowEqual, useDispatch, useSelector} from 'react-redux';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import {hardwareIcKeyboardArrowDown24px} from '@ey/motif-react-wrapper/assets/icons/index';
import {getAccountById} from '../../../../selectors/Ares/selectors';
import {AccountType} from '../../../../util/uiconstants';
import {currentResource, labels} from '../../../../util/utils';
import ChangeAccountDesignationModal from '../ChangeAccountDesignationModal/ChangeAccountDesignationModal';
import {getAccountType} from './AccountSummaryConfig';
import {getAccountById as apiCall} from '../../../../actions/Account/accountactions';
import {useEngagement} from '../../../../util/customHooks';
import AccountDesignation from './AccountDesignation';
import Icon from '../../BaseComponentWrappers/MotifIcon';
import IconButton from '../../BaseComponentWrappers/MotifIconButton';
import DropdownItem from '../../BaseComponentWrappers/MotifDropdownItem';
import Dropdown from '../../BaseComponentWrappers/MotifDropdown';

function Designation({className, accountId, setShowModal, hideDropdown}) {
	const {accountTypeId, priorAccountTypeID} =
		useSelector((state) => getAccountById(state, accountId), shallowEqual) || {};

	const [isOpen, setIsOpen] = useState(false);
	const dispatch = useDispatch();
	const {engagementId} = useEngagement();

	const [showModal, setShowModalConfirm] = useState(false);

	const [_accountTypeId, setAccountTypeId] = useState();
	const [_accountTypeName, setAccountTypeName] = useState();

	const id = `dropdown-${accountId}`;

	const triggerId = `dropdown-trigger-${accountId}`;

	return (
		<StyledSection className={`DesignationBodyCell ${className}`}>
			{!hideDropdown ? (
				<Dropdown
					handleClickOutside={() => setIsOpen(false)}
					open={isOpen}
					id={id}
					ariaLabelledBy={triggerId}
					portalClassName="designation-dropdown"
					usePortal
					trigger={
						<IconButton
							id={triggerId}
							type="button"
							onClick={() => setIsOpen(true)}
							ariaControls={id}
							ariaExpanded={isOpen}
							ariaLabel={`dropdown trigger ${accountId}`}
							children={
								accountTypeId ? (
									<AccountDesignation accountTypeId={accountTypeId} onClick={() => setIsOpen(true)}>
										<Icon className="designation-icon" src={hardwareIcKeyboardArrowDown24px} />
									</AccountDesignation>
								) : (
									<></>
								)
							}
						/>
					}
					children={
						<>
							{currentResource.AccountType.map((accountType) => (
								<DropdownItem
									className={accountTypeId === accountType.id && 'selected-designation'}
									onClick={() => {
										setIsOpen(false);
										if (accountType.id !== AccountType.Significant) {
											setShowModalConfirm(true);
										} else {
											setShowModal(accountId);
											dispatch(apiCall(engagementId, accountId));
										}
										setAccountTypeId(accountType.id);
										setAccountTypeName(accountType.accounttypename);
									}}
									children={<b>{accountType.accounttypename}</b>}
								/>
							))}
							<DropdownItem
								className="py-designation"
								children={
									<span className="pydesignation-label">
										{labels.pydesignation}
										{'   '}
										{priorAccountTypeID ? getAccountType(priorAccountTypeID) : labels.notapplicable}
									</span>
								}
							/>
						</>
					}
				/>
			) : (
				<AccountDesignation accountTypeId={accountTypeId} onClick={() => {}} />
			)}
			{showModal && (
				<ChangeAccountDesignationModal
					accountId={accountId}
					_accountTypeId={_accountTypeId}
					accountTypeName={_accountTypeName}
					show={showModal}
					setShow={setShowModalConfirm}
				/>
			)}
		</StyledSection>
	);
}

Designation.propTypes = {
	className: PropTypes.string,
	accountId: PropTypes.number.isRequired
};

Designation.defaultProps = {
	className: 'designation-cellrenderer'
};

export default Designation;

const StyledSection = styled.section`
	.designation-icon {
		svg {
			color: var(--neutrals-900);
		}
	}
	.motif-dropdown-trigger .motif-button[aria-expanded='true'] {
		.designation-icon svg {
			transform: rotate(180deg);
		}
	}
`;
